// Version 0.0.1
// VAIBAV
// MODIFIED DATA : 23-12-2025

import CollectionFormatReportTypes from './collection-format-report.types';
import { docodeHexResponse } from '../../_common/common.utils';

const INITIAL_STATE = {
	fetchCollectionFormatDetailResponse: null,
	fetchNPADetailArr: [],
};

const collectionFormatReportReducer = (state = INITIAL_STATE, action: any) => {
	switch (action.type) {
		/* ****************FETCH CollectionInterestDETAILS START ********************** */
		case CollectionFormatReportTypes.FETCH_COLLECTION_FORMAT_REPORT_SUCCESS:
			return {
				...state,
				fetchCollectionFormatDetailResponse: action.payload,
				fetchCollectionFormatDetailArr: docodeHexResponse(
					action.payload,
					'GetCollectionFormatReportDetailsKey',
				),
			};

		case CollectionFormatReportTypes.FETCH_COLLECTION_FORMAT_REPORT_FAILURE:
			return { ...state, fetchCollectionFormatDetailResponse: action.payload };

		case CollectionFormatReportTypes.FETCH_COLLECTION_FORMAT_REPORT_RESPONSE_CHANGED:
			return { ...state, fetchCollectionFormatDetailResponse: null };
		/* ****************************FETCH CollectionFormat DETAILS END **************** */
		default:
			return state;
	}
};
export default collectionFormatReportReducer;
